module.exports = __webpack_public_path__ + "static/media/quality.105633f0.png";